"use strict";

var _classCallCheck = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FDSUtils = _interopRequireDefault(require("./FDS-Utils.js"));

var _User = _interopRequireDefault(require("./models/User.js"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} //rename to account store
// Copyright 2019 The FairDataSociety Authors
// This file is part of the FairDataSociety library.
//
// The FairDataSociety library is free software: you can redistribute it and/or modify
// it under the terms of the GNU Lesser General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// The FairDataSociety library is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
// GNU Lesser General Public License for more details.
//
// You should have received a copy of the GNU Lesser General Public License
// along with the FairDataSociety library. If not, see <http://www.gnu.org/licenses/>.
// stores user accounts
// https://stackoverflow.com/questions/28572380/conditional-build-based-on-environment-using-webpack
// if (typeof localStorage === "undefined" || localStorage === null) {
//   var LocalStorage = require('node-localstorage').LocalStorage;
//   var localStorage = new LocalStorage('./scratch');
// }


var fs = null;

if (typeof localStorage === 'undefined') {
  fs = require('fs');
}

var UserStore =
/*#__PURE__*/
function () {
  /**
   * Create user store
   * @param {any} config configuration settings
   * @param {any} Account to use
   */
  function UserStore(config, Account) {
    _classCallCheck(this, UserStore);

    this.config = config;
    this.Account = Account;
    this.users = this.getAll();
  }
  /**
   * Get subdomain
   * @param {string} subdomain name
   * @returns {User} user 
   */


  _createClass(UserStore, [{
    key: "get",
    value: function get(subdomain) {
      var results = this.getAll().filter(function (user) {
        return user.subdomain === subdomain;
      });

      if (results.length === 1) {
        return new _User.default(results[0], this.Account);
      } else if (results.length === 0) {
        return false;
      } else {
        throw new Error('there should only be one result per subdomain');
      }
    }
    /**
     * Get subdomain
     * @param {string} subdomain name
     * @returns {User} user 
     */

  }, {
    key: "getByAddress",
    value: function getByAddress(address) {
      var results = this.getAll().filter(function (user) {
        return user.wallet.address === address;
      });

      if (results.length === 1) {
        return new _User.default(results[0], this.Account);
      } else if (results.length === 0) {
        return false;
      } else {
        throw new Error('there should only be one result per address');
      }
    }
    /**
     *  Get all users
     *  @returns {User} returns users from local storage
    */

  }, {
    key: "getAll",
    value: function getAll(walletVersion) {
      if (this.config.walletVersion === undefined) {
        walletVersion = 0; //backwards compatibility
      }

      var wv = walletVersion === undefined ? this.config.walletVersion : walletVersion;
      var key = this.config.chainID ? "fds-users_".concat(this.config.chainID) : 'users';
      var value;

      if (typeof localStorage === 'undefined') {
        value = fs.readFileSync("./scratch/".concat(key));
      } else {
        value = localStorage.getItem(key);
      }

      if (value === null) {
        return [];
      } else {
        var users = [];
        var usersIndex = JSON.parse(value);

        for (var i = usersIndex.length - 1; i >= 0; i--) {
          if (wv === 0 && usersIndex[i].version === undefined || //backwards compatibility
          wv === usersIndex[i].version) {
            users.push(new _User.default(usersIndex[i], this.Account));
          }
        }

        return users;
      }
    }
    /**
     * Add user to subdomain 
     * @param {any} subdomain name 
     * @param {any} wallet to use
     * @returns {User} user
     */

  }, {
    key: "addUser",
    value: function addUser(wallet) {
      var subdomain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (this.getByAddress(wallet.address) === false) {
        var user = new _User.default({
          version: this.config.walletVersion,
          subdomain: subdomain,
          wallet: wallet
        }, this.Account);
        this.users.push(user);
        this.saveAll();
        return user;
      } else {
        throw new Error('user already present in local storage');
      }
    }
    /**
     * Delete subdomain
     * @param {any} subdomain name
     */

  }, {
    key: "delete",
    value: function _delete(subdomain) {
      this.users = this.getAll().filter(function (user) {
        return user.subdomain !== subdomain;
      });
      this.saveAll();
    }
    /**
     * Save all 
     * @returns {any} result 
     */

  }, {
    key: "saveAll",
    value: function saveAll() {
      var key = this.config.chainID ? "fds-users_".concat(this.config.chainID) : 'users';
      var users = [];

      for (var i = this.users.length - 1; i >= 0; i--) {
        users.push(this.users[i].toJSON());
      }

      if (typeof localStorage === 'undefined') {
        return fs.writeFileSync("./scratch/".concat(key), JSON.stringify(users));
      } else {
        return localStorage.setItem(key, JSON.stringify(users));
      }
    }
    /**
     * Restore subdomain from JSON wallet 
     * @param {string} subdomain name
     * @param {string} walletJSONString json wallet as string
     * @returns {User} user
     */

  }, {
    key: "restore",
    value: function restore(subdomain, walletJSONString) {
      var wallet = JSON.parse(walletJSONString);
      return this.addUser(wallet, subdomain);
    }
  }]);

  return UserStore;
}();

var _default = UserStore;
exports.default = _default;
module.exports = exports.default;